import { render, staticRenderFns } from "./quesAppointComponent.vue?vue&type=template&id=5e2c97b6&scoped=true&"
import script from "./quesAppointComponent.vue?vue&type=script&lang=js&"
export * from "./quesAppointComponent.vue?vue&type=script&lang=js&"
import style0 from "./quesAppointComponent.vue?vue&type=style&index=0&id=5e2c97b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c97b6",
  null
  
)

export default component.exports